// import { Component, OnInit } from '@angular/core';
// import { ICellRendererAngularComp } from 'ag-grid-angular';
// import { ICellRendererParams } from 'ag-grid-community';
// import { AgGridService } from '../ag-grid.service';

// @Component({
//   selector: 'app-checkbox-cellrender',
//   templateUrl: './checkbox-cellrender.component.html',
//   styleUrls: ['./checkbox-cellrender.component.scss']
// })
// export class CheckboxCellrenderComponent implements  OnInit,  ICellRendererAngularComp {
//   params;
//   checkBoxValue:boolean = false;
//   constructor(public agGridService: AgGridService,) {}
//   ngOnInit(): void {}
//   agInit(params: ICellRendererParams<any, any>): void {
//     this.params = params;

// }
// refresh(params: ICellRendererParams<any, any>): boolean {
//   return false
// }
// onChange(params ,additionalValue){
//   if(additionalValue !== undefined){
//   console.log(params,additionalValue);
//   const selectedValue = { data: this.params.data, additionalValue: additionalValue };
//   this.agGridService. selectionChanged.next(selectedValue)
// }
// }
// }

import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { AgGridService } from "../ag-grid.service";
import { CommonPopupComponent } from "../../../common-popup/common-popup.component";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { NotificationService } from "../../../services/notification.service";

@Component({
  selector: "app-checkbox-cellrender",
  templateUrl: "./checkbox-cellrender.component.html",
  styleUrls: ["./checkbox-cellrender.component.scss"],
})
export class CheckboxCellrenderComponent
  implements OnInit, ICellRendererAngularComp
{
  @Input() label: string = ""; // Label next to checkbox
  @Output() valueChange = new EventEmitter<{ data: any; checked: boolean }>(); // Emits value changes
  params: any;
  checkBoxValue: boolean = false;
  @Input() disabled: boolean = false;
  @Input() isCursor: boolean = false;
  additionalValue: any;
  ngOnInit(): void {}

  constructor(
    public agGridService: AgGridService,
    public modalService: NgbModal,
    public notification: NotificationService
  ) {}
  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.disabled = this.params?.disabled || this.disabled;
    this.checkBoxValue = this.params.value || false; // Set initial value based on cell data
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.checkBoxValue = this.params.value || false;
    return true;
  }

  onCheckboxChange(params, additionalValue): void {
    if (!this.disabled) {
      this.additionalValue = additionalValue;
      if (this.params?.confirmPopup) {
        this.openConfirmationPopup();
      } else {
        this.changeValue();
      }
    }
  }

  changeValue() {
    const checked = this.checkBoxValue;
    const field = this.params?.colDef?.field;
    this.params.node.setSelected(checked);
    if (field) {
      this.params.node.setDataValue(field, checked);
    }
    const selectedValue = {
      data: this.params.data,
      additionalValue: this.additionalValue,
    };
    this.agGridService.selectionChanged.next(selectedValue);
    const customEvent = new CustomEvent('checkBoxClick', {
      detail: { data: this.params },
    });
    this.params.api.dispatchEvent(customEvent);
  }

  openConfirmationPopup(): void {
    this.notification
      .confirmationPopup(
        "Save",
        `Are you sure you want to save this record ?`,
        "save",
        false,
        "Save",   
        "Cancel",
        true
      )
      .subscribe((result) => {
        if (result?.isConfirmed) {
          this.changeValue();
        } else {
          this.checkBoxValue = !this.checkBoxValue;
        }
      });
  }
}
